export default {"src":"/_next/static/media/chrome-share.3516c7ff.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};